import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import './Home.css';

function Home() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/patents?per_page=1`);
        setStats({
          total: response.data.total
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="home">
      <div className="hero">
        <h1>Patent Catalogue Visualization</h1>
        <p className="tagline">Explore, visualize, and investigate patent data</p>
      </div>

      {!loading && stats && (
        <div className="stats-card">
          <h2>Portfolio Overview</h2>
          <div className="stat-number">{stats.total}</div>
          <p>Total Patents</p>
        </div>
      )}

      <div className="features-grid">
        <Link to="/catalogue" className="feature-card">
          <h3>📚 Catalogue View</h3>
          <p>Browse patents in a beautiful two-page catalogue layout with table of contents organized by domains, problem spaces, and solution spaces.</p>
        </Link>

        <Link to="/search" className="feature-card">
          <h3>🔍 Advanced Search</h3>
          <p>Search patents by keywords across multiple fields including title, abstract, claims, and technical descriptions.</p>
        </Link>

        <Link to="/navigation" className="feature-card">
          <h3>🧭 Portfolio Navigation</h3>
          <p>Navigate through patents by dimensions, visualize portfolio clusters, and perform spec-based infringement analysis.</p>
        </Link>

        <Link to="/pipeline" className="feature-card">
          <h3>🛠 Pipeline Control</h3>
          <p>Upload patent lists, kick off batch jobs, and watch live progress for every phase of the pipeline.</p>
        </Link>
      </div>
    </div>
  );
}

export default Home;
